const THRESHOLD_OPTIONS = {
  0: {
    value: 0,
    label: "Low",
    text: "Low Threshold: Your answer will be broad and diverse.",
  },
  0.85: {
    value: 0.85,
    label: "Medium",
    text: "Medium Threshold: Your answer will be balanced between relevance and variety.",
  },
  1.7: {
    value: 1.7,
    label: "High",
    text: "High Threshold: Your answer will be highly precise and relevant.",
  },
};
export default THRESHOLD_OPTIONS;
